module.exports = __webpack_public_path__ + "static/media/account-icon.8ff78ad8.svg";